import React from 'react';

const MenuContext = React.createContext(null);

export default MenuContext;


// WEBPACK FOOTER //
// ./src/lib/MenuContext/index.js